import {
  SET_LEFT_NAV_DATA,
  SELECTED_NAV_ITEM,
  REMOVE_NAV_ITEM,
  REMOVE_NAV_SUB_ITEM,
  ADD_SUB_ITEM,
  RETURN_INITIAL_NAV_DATA,
  UPDATE_INITIAL_NAV_DATA,
} from '@/store/modules/left-nav-customization/mutation-types';
import { cloneDeep } from 'lodash-es';

export default {
  [SET_LEFT_NAV_DATA](state, payload){
    state.leftNavData = payload;
    state.initialLeftNavData = cloneDeep(payload);
  },
  [SELECTED_NAV_ITEM](state, payload) {
    state.selectedNavItem = payload;
  },
  [REMOVE_NAV_ITEM](state, id){
    state.leftNavData = state.leftNavData.filter(x=>x.id !== id);
  },
  [REMOVE_NAV_SUB_ITEM](state, id){
    state.selectedNavItem.subItems = state.selectedNavItem.subItems.filter(sub =>sub.id !== id);
  },
  [ADD_SUB_ITEM](state, payload){
    state.selectedNavItem.subItems.push(payload);
  },
  [RETURN_INITIAL_NAV_DATA](state){
    state.leftNavData = cloneDeep(state.initialLeftNavData);
    state.selectedNavItem = null;
  },
  [UPDATE_INITIAL_NAV_DATA](state, payload){
    state.initialLeftNavData = payload;
  },
};